export const SET_TABLE_RECORDS          = "SET_TABLE_RECORDS";
export const UPDATE_TABLE_RECORDS       = "UPDATE_TABLE_RECORDS";
export const RESET_TABLE_RECORDS        = "RESET_TABLE_RECORDS";
export const SET_LOOKUP_FIELDS_RECORDS  = "SET_LOOKUP_FIELDS_RECORDS";